
export class ClassificationGroup {

  public id: string;
  public name: string;
  public classificationTypeId: string;
  public sortOrder: number;
  public sortDir: string;
  public visible: boolean = true;
  public items: any[];
}
